import { render, staticRenderFns } from "./MhMultipleSelect.vue?vue&type=template&id=07caf4c3&scoped=true&"
import script from "./MhMultipleSelect.vue?vue&type=script&lang=js&"
export * from "./MhMultipleSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07caf4c3",
  null
  
)

export default component.exports